import script from "./SkeletonItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonItem.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonItem.vue?vue&type=style&index=0&id=7d756de1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d756de1"]])

export default __exports__